import './artificialStreamingResponse.css';
import {ListGroup} from 'react-bootstrap'

export default function ArtificialStreamingResponse(props) {

    // if ( props.data.isError ){
    //     console.log("isError")
    //     console.log(props)
    //     return(
    //         <div className="response error">
    //             <b>{props.data.errorMessage}</b>
    //         </div>
    //         )
    // }
    
    if ( props.data.ingestionResponses ) {
        console.log("data:")
        console.log(props.data)
    
        let counter = 0
        return(
            <div>
                <p></p>
                <h3>Artificial streams data ingestion for {props.data.ingestionResponses[0].date}</h3>
                <p></p>
                {props.data.ingestionResponses.map( r => 
                                        <div>
                                            <ListGroup horizontal="sm" className="my-2" key={counter++}>
                                                <ListGroup.Item>DSP: {r.dsp}</ListGroup.Item>
                                                <ListGroup.Item>Total no of data rows ingested: {r.lineCount}</ListGroup.Item>
                                                <ListGroup.Item>Total no of error rows: {r.errorCount}</ListGroup.Item>
                                                <ListGroup.Item>Errors: {r.errorMessage}</ListGroup.Item>
                                            </ListGroup>
                                        </div>)}
            </div>
        )
    }
    else{
        console.log(props)
        return(<div className="spinner-border text-primary" role="status">
        <span className="sr-only"></span>
      </div>)
    }

}